// @flow

import { CALCULATE_MY_QUOTE, LIFE_QUOTE, QUOTE_CTA_CLICK } from 'routes/life/constant';
import { Tracking } from 'web-core/src/tracking';

const LIFE_PAGE = 'Life';

export const trackLifeQuote = (CTA: string, userInfo: Object) => {
  Tracking.track(LIFE_QUOTE, {
    Page: LIFE_PAGE,
    CTA,
    ...userInfo,
  });
};

export const trackQuoteBtnClick = () => {
  Tracking.track(CALCULATE_MY_QUOTE, {
    CTA: QUOTE_CTA_CLICK,
  });
};
